import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {
  RemoveCartLineFromCartViewModel
} from "@app/presentation/components/remove-cart-line-from-cart/remove-cart-line-from-cart.view-model";
import {Product} from "@app/core/product/domain/dtos/product";

@Component({
  selector: 'ep-remove-cart-line-from-cart',
  templateUrl: './remove-cart-line-from-cart.component.html',
  styleUrls: ['./remove-cart-line-from-cart.component.scss'],
  providers: [RemoveCartLineFromCartViewModel]
})
export class RemoveCartLineFromCartComponent implements OnChanges {

  @Input() product?: Product | null = null;

  @Input() promotionCode?: string | null = null;

  @Input() marginRightPx?: number = 0;

  isCartLineInCart$ = this.removeCartLineFromCartViewModel.isCartLineInCart$;

  constructor(private removeCartLineFromCartViewModel: RemoveCartLineFromCartViewModel) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.product != null) {
      this.removeCartLineFromCartViewModel.setProductCode(this.product)
    }
    if (this.promotionCode) {
      this.removeCartLineFromCartViewModel.setPromotionCode(this.promotionCode)
    }
  }

  removeCartLine() {
    this.removeCartLineFromCartViewModel.removeCartLine();
  }

}
